import React from 'react'

import './css/Connect.css'
import { ConnectEducatorsText, ConnectEmployersText, ConnectVendorsText } from './text/connect-text'

const ConnectTypes = {
  Educator: 'Educator',
  Employer: 'Employer',
  Vendor: 'Vendor'
}

const ConnectHeaderText = {
  Educator: 'FOR EDUCATORS',
  Employer: 'FOR EMPLOYERS',
  Vendor: 'FOR VENDORS'
}

export default class Connect extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      isSmallScreen: false,
      type: ConnectTypes.Educator
    }
  }

  componentWillMount() {
    if (this.props.type) {
      this.checkPage()
    }
    window.addEventListener('resize', this.onResize)
    this.onResize()
  }

  componentDidReceiveProps = nextProps => {
    this.checkPage()
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.onResize)
  }

  changePage = ev => {
    this.setState({
      type: ev.target.dataset.type
    })
  }

  checkPage = () => {
    let { type } = this.props
    if (ConnectTypes[type]) {
      this.setState({
        type: ConnectTypes[type]
      })
    }
  }

  onResize = () => {
    let isSmallScreen = !!(window.innerWidth < 800)
    this.setState({
      isSmallScreen
    })
  }

  renderContent = () => {
    switch (this.state.type) {
      case ConnectTypes.Educator:
        return this.renderEducatorsPage()
      case ConnectTypes.Employer:
        return this.renderEmployersPage()  
      case ConnectTypes.Vendor:
        return this.renderVendorsPage()  
      default:
        return null
    }
  }

  renderEducatorText = text => (
    <div key={text} className="line small-text">{text}</div>
  )

  renderEducatorsPage = () => (
    <div className="educators-page">
      <div className="connect-subheader">{ConnectEducatorsText[1]}</div>
      <div className="section">
        <div className="small-text">{ConnectEducatorsText[2]}</div>
      </div>
      <div className="section">
        <div className="small-text">{ConnectEducatorsText[3]}</div>
      </div>
      <div className="section">
        <div className="small-text">{ConnectEducatorsText[4]}</div>
      </div>
      <div className="section two">
        <div className="left-row">
          <div className="connect-subheader">The Typical Student</div>
          {ConnectEducatorsText.slice(5, 8).map(this.renderEducatorText)}
        </div>
        <div className="right-row">
          <div className="connect-subheader">The standard AcademME member is</div>
          {ConnectEducatorsText.slice(8, 12).map(this.renderEducatorText)}
        </div>
      </div><br/ >
      <div className="section">
        <div className="connect-subheader">{ConnectEducatorsText[12]}</div>
        {ConnectEducatorsText.slice(13, 20).map(this.renderEducatorText)}
      </div>
    </div>
  )

  renderEmployersPage = () => (
    <div className="employers-page">
      <div className="section">
        <div className="connect-subheader">{ConnectEmployersText[0]}</div>
      </div>
      <div className="section">
        <div className="small-text">{ConnectEmployersText[1]}</div>
      </div>
      <div className="section">
        <div className="connect-subheader">{ConnectEmployersText[2]}</div>
      </div>
      <div className="section">
        <div className="small-text">{ConnectEmployersText[3]}</div>
      </div>
      <div className="section">
        <div className="small-text">{ConnectEmployersText[4]}</div>
      </div>
    </div>
  )

  renderType = () => (
    <div className="type-page">
      <div className="about-header lower">{ConnectHeaderText[this.state.type]}</div>
      {this.renderContent()}
    </div>
  )

  renderVendorsPage = () => (
    <div className="vendors-page">
      <div className="section">
        <div className="connect-subheader">{ConnectVendorsText[0]}</div>
      </div>
      <div className="section">
        <div className="small-text">{ConnectVendorsText[1]}</div>
      </div>
      <div className="section">
        <div className="small-text">{ConnectVendorsText[2]}</div>
      </div>
      <div className="section">
        <div className="small-text">{ConnectVendorsText[3]}</div>
      </div>
    </div>
  )

  render() {
    let { isSmallScreen, type } = this.state

    return (
      <div className="connect-container">
        <div className="about-header">CONNECT WITH STUDENTS</div>
        <div className="small-text">{ConnectEducatorsText[0]}</div>
        <div className="connect-menu">
          <div className="options">
            <div
              data-type={ConnectTypes.Educator}  
              onClick={this.changePage}  
              className={
                `option-item ${type === ConnectTypes.Educator ? 'selected' : ''}`
              }>{ConnectHeaderText.Educator}</div>
              {isSmallScreen && type === ConnectTypes.Educator ? this.renderType() : null}
            <div
              data-type={ConnectTypes.Employer}
              onClick={this.changePage}   
              className={
                `option-item ${type === ConnectTypes.Employer ? 'selected' : ''}`
              }>{ConnectHeaderText.Employer}</div>
            {isSmallScreen && type === ConnectTypes.Employer ? this.renderType() : null}
            <div
              data-type={ConnectTypes.Vendor}
              onClick={this.changePage}  
              className={
              `option-item ${type === ConnectTypes.Vendor ? 'selected' : ''}`
              }>{ConnectHeaderText.Vendor}</div>
            {isSmallScreen && type === ConnectTypes.Vendor ? this.renderType() : null}
          </div>
        </div>
        <div className="connect-text">
          {!isSmallScreen ? this.renderType() : null}
          <div className="connect-contact">
            <div className="section">
              <div className="connect-subheader">{ConnectEducatorsText[20]}</div>
              <div className="small-text">Email us at: <a href="">info@academme.co</a></div>
              <div className="small-text">{ConnectEducatorsText[21]}</div>
            </div>
        </div>

        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// src/Connect.js